import React from 'react';
import { Link, Stack, Typography, Box, SxProps, Theme } from '@mui/material';
import { error, neutral, success, warning } from '_lex/_foundations/phxColors';

export type PercentBarVariant = 'danger' | 'info' | 'neutral' | 'primary' | 'success' | 'warning';

export type PercentBarProps = {
  percent: number;
  variant?: PercentBarVariant;
  sx?: SxProps<Theme>;
};

const variantColors = {
  danger: `linear-gradient(90deg, ${error[500]} 0%, ${error[600]} 100%)`,
  warning: `linear-gradient(90deg, ${warning[500]} 0%, ${warning[600]} 100%)`,
  success: `linear-gradient(90deg, ${success[500]} 0%, ${success[600]} 100%)`,
};

const PercentBar: React.FC<PercentBarProps> = ({ percent, variant = 'neutral', sx }) => {
  return (
    <Box
      sx={{
        height: 8,
        borderRadius: 2,
        border: `solid 1px ${neutral[300]}`,
        backgroundColor: neutral[100],
        ...sx,
      }}
    >
      <Box
        sx={{
          height: '100%',
          width: `${percent}%`,
          borderRadius: 2,
          background: variantColors[variant as keyof typeof variantColors],
        }}
      ></Box>
    </Box>
  );
};

export default PercentBar;
